import { lazyPage } from '../../utils/lazyPage';

export const ToolsHub = lazyPage(() => import('./ToolsHub'));
export const EvCalculator = lazyPage(() => import('./EvCalculator'));
export const KellyCalculator = lazyPage(() => import('./KellyCalculator'));
export const ParlayCalculator = lazyPage(() => import('./ParlayCalculator'));
export const OddsConverter = lazyPage(() => import('./OddsConverter'));
export const ImpliedProbabilityCalculator = lazyPage(() => import('./ImpliedProbabilityCalculator'));
export const HedgeCalculator = lazyPage(() => import('./HedgeCalculator'));
export const VigCalculator = lazyPage(() => import('./VigCalculator'));
